import { c as _c } from "react/compiler-runtime";
import { CurrencyFormatter } from "@sticker-giant/sg-frontend-common";
import { Skeleton } from "@/components/ui/skeleton";
import { isFinishedGood } from "@/lib/product/product";
import { usePdpParams } from "@/providers/PdpParamsProvider";
import { useProduct } from "@/queries/useProduct";
import { useStartingPrice } from "@/queries/useStartingPrice";
import { useProductBuilderContext } from "./ProductBuilderContext";
export default function StartingAtPrice() {
  const $ = _c(5);
  const {
    product
  } = useProductBuilderContext();
  const {
    quantity: quantityParam
  } = usePdpParams();
  const {
    data: productData,
    isLoading: isProductLoading
  } = useProduct(product.sku);
  const {
    data: startingPriceData,
    isLoading: isStartingPriceLoading
  } = useStartingPrice(productData);
  if (quantityParam !== undefined) {
    return null;
  }
  if (productData && isFinishedGood(productData)) {
    return null;
  }
  if (isProductLoading || isStartingPriceLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Skeleton className="h-4 w-34 mb-6" />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  const startingPrice = Number(startingPriceData?.quantityPrices[0]?.price);
  if (Number.isNaN(startingPrice)) {
    return null;
  }
  let t0;
  if ($[1] !== startingPrice) {
    t0 = CurrencyFormatter.formatUSD(startingPrice);
    $[1] = startingPrice;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = <p className="font-bold mb-6 leading-none tabular-nums">Starting at {t0}</p>;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}